import * as React from "react";

import { useControlledContextualMenuByMenuButton } from "../../AppFlyoutAnchor/next";
import type {
  AppSplitButtonProps,
  AppSplitButtonState,
} from "./AppSplitButton.types";

export const useAppSplitButtonState = (
  props: AppSplitButtonProps,
  state: AppSplitButtonState
): AppSplitButtonState => {
  const { onClick, disabled } = state.primaryActionButton;
  const [hideMenuFromPrimaryButton, setHideMenuFromPrimaryButton] =
    React.useState<boolean>(false);

  useControlledContextualMenuByMenuButton(
    { ...props, onExecute: props.onMenuButtonExecute },
    state,
    state.root.ref
  );

  // Adding onClick to the primary button to close the menu if it's open
  const onButtonClick = React.useCallback(
    (
      ev: React.MouseEvent<HTMLButtonElement> &
        React.MouseEvent<HTMLAnchorElement>
    ) => {
      if (disabled) {
        return;
      }
      onClick?.(ev);

      if (!state.menu.hidden) {
        setHideMenuFromPrimaryButton(true);
        // Set the menu button aria expanded to false and calling the menu onDismiss
        state.menuButton["aria-expanded"] = false;
        state.menu.onDismiss?.();
      }
    },
    [onClick, state.menu, state.menuButton, disabled]
  );

  state.primaryActionButton.onClick = onButtonClick;

  // Once the menu has been hidden, reset the state so the menu can be opened again from the menu button
  if (hideMenuFromPrimaryButton) {
    state.menu.hidden = true;
    setHideMenuFromPrimaryButton(false);
  }

  // Create menuHidden prop to pass to MenuButton
  // This is for styling, to know if the MenuButton should style in the "expanded" state
  state.menuButton.menuHidden = state.menu.hidden;
  state.menu.useLegacyContextMenu = props.useLegacyContextMenu;

  return state;
};
